import { User } from "@src/interfaces/user.interface";
import { ProfileDTO } from "./types";

export const convertProfileApiDataToUser = (data: ProfileDTO): User => {
    return {
        id: data.userUuid,
        name: data.firstName,
        lastName: data.lastName,
        email: data.user.email,
        phone: data.user.phone,
        isEmailVerified: data.user.isEmailVerified,
        isPhoneVerified: data.user.isPhoneVerified,
        isNotificationEnabled: data.isNotificationEnabled,
        isCompany: data.user.isCompany
    };
};